import { LINKS } from '@/shared/config/links';
import { Banner } from '@/shared/ui/banner';
import { Card } from '@/shared/ui/card';
import type { UseCheckoutFlowResult } from '../hooks/use-checkout-flow';
import { usePlanChangePreview } from '../hooks/use-plan-change-preview';
import type { WorkspaceData } from '../types';
import { ChangePlanSummary } from './change-plan-summary';
import { NewPlanCheckout } from './new-plan-checkout';

type CheckoutSummaryCardProps = { workspace: WorkspaceData; flow: UseCheckoutFlowResult };

export function CheckoutSummaryCard({ workspace, flow }: CheckoutSummaryCardProps) {
  const isSkipped = !flow.isChange || flow.plan === flow.currentPlan || flow.isPaymentsOff;
  const { preview, isLoading } = usePlanChangePreview(flow.plan, isSkipped);
  const title = flow.isChange
    ? preview?.isUpgrade === false
      ? 'Change plan'
      : 'Upgrade'
    : 'Checkout';

  return (
    <Card asChild>
      <aside
        data-enter=""
        aria-labelledby="sum-h"
        className="flex min-w-0 shrink grow basis-105 flex-col gap-4.5 p-6"
      >
        <h2 id="sum-h" className="font-semibold text-card-title">
          {title}
        </h2>
        {flow.isChange ? (
          <ChangePlanSummary
            workspace={workspace}
            flow={flow}
            preview={preview}
            isLoading={isLoading}
          />
        ) : (
          <NewPlanCheckout workspace={workspace} flow={flow} />
        )}
        {flow.isPaymentsOff ? (
          <Banner tone="info" title="Paid plans open soon.">
            Write to {LINKS.SUPPORT_EMAIL} to start one now.
          </Banner>
        ) : null}
      </aside>
    </Card>
  );
}
